/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RichTextWithImage } from "cms/rich-text/rich-text-with-image";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { ORIENTATION } from "cms/images/image-selector/image-selector-config";

const RichTextWithImageComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const { token } = useAuth();
    const component = ctx?.component;
    const hide = ctx?.hide;
    
    const {
        richtext,
        image: _image,
        side = "left",
        displayWidth,
        displayHeight
    } = component || {};
    
    const [image, setImage] = useState();
    const [orientation, setOrientation] = useState(ORIENTATION.HORIZONTAL);
    
    useEffect(() => {
        async function fetchData () {
            if (_image) {
                const data = await SimpliCityAdminSDK.images.findOne(token, _image);
                setImage(data);
                const _orientation = (data.width > data.height) ? ORIENTATION.HORIZONTAL : ORIENTATION.VERTICAL;
                setOrientation(_orientation);
            }
        }
        fetchData();
    }, [token, _image]);
    
    return (
        <>
            {!hide &&
                <div className='simplicity-richtext-wrap'>
                    <RichTextWithImage
                        richtext={richtext}
                        image={image}
                        side={side}
                        displayWidth={displayWidth}
                        displayHeight={displayHeight}
                        orientation={orientation}
                    />
                </div>
            }
        </>
    );
};

RichTextWithImageComponentDisplay.displayName = "RichTextWithImageComponentDisplay";
export { RichTextWithImageComponentDisplay };
